import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Monitor, Loader2 } from 'lucide-react';
import TabTip from '../ui/TabTip';

const formatSessionDate = (dateString) => new Date(dateString).toLocaleString();

const DeviceSessionsCard = ({ showDeviceSessions, setShowDeviceSessions, activeSessions, onLogoutAll, actionLoading }) => (
  <Card>
    <CardHeader>
      <div className="flex items-center justify-between">
        <div>
          <CardTitle className="flex items-center space-x-2">
            <Monitor className="w-5 h-5" /><span>Manage Active Devices</span><TabTip tip="manage_active_devices" showIcon={true} />
          </CardTitle>
          <CardDescription>Manage devices that are currently logged into your account</CardDescription>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant="outline">{activeSessions.length} active</Badge>
          <Button variant={showDeviceSessions ? "default" : "outline-solid"} size="sm" className={showDeviceSessions ? "bg-slate-800 hover:bg-slate-700 text-white" : ""} onClick={() => setShowDeviceSessions(!showDeviceSessions)} data-testid="manage-device-sessions-btn">
            {showDeviceSessions ? 'Hide Devices' : 'View Devices'}
          </Button>
        </div>
      </div>
    </CardHeader>
    {showDeviceSessions && (
      <CardContent className="space-y-4">
        <div className="space-y-3">
          {activeSessions.length > 0 ? (
            activeSessions.map((session, index) => (
              <div key={session.session_id || `session-${index}`} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <Monitor className="w-5 h-5 text-slate-400" />
                  <div>
                    <p className="text-sm font-medium text-slate-900">{session.device_info || 'Unknown Device'}</p>
                    <p className="text-xs text-slate-500">{session.ip_address || 'Unknown IP'} &bull; Last active: {formatSessionDate(session.last_activity)}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-slate-500">No active sessions found.</p>
          )}
        </div>
        <Button onClick={onLogoutAll} disabled={actionLoading || activeSessions.length === 0} variant="outline" className="w-full border-red-300 text-red-600 hover:bg-red-50 hover:text-red-700 hover:border-red-400">
          {actionLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
          Logout All Devices ({activeSessions.length} sessions)
        </Button>
      </CardContent>
    )}
  </Card>
);

export default DeviceSessionsCard;
